var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CurrentTime'),_c('div',{staticClass:"container"},[_c('button',{staticClass:"entrada",on:{"click":_vm.record}},[_vm._v("COM VOZ (1)")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }